window.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('[data-header-sticky="true"]')) {
		document.getElementsByTagName('html')[0].classList.add('tpt-header-sticky-enabled');
	}
});

function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
	});

	if (summary.closest('header-drawer, menu-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();

	if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
		elementToFocus.setSelectionRange(0, elementToFocus.value.length);
	}
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(':focus-visible');
} catch (e) {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		'focus',
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add('focused');
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', { bubbles: true });
		this.input.addEventListener('change', this.onInputChange.bind(this));
		this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
	}

	quantityUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.validateQtyRules();
		this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
	}

	disconnectedCallback() {
		if (this.quantityUpdateUnsubscriber) {
			this.quantityUpdateUnsubscriber();
		}
	}

	onInputChange(event) {
		this.validateQtyRules();
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

		if (this.closest('product-info') && !this.closest('.quickview-modal') && document.querySelector('.sticky-button-cart')) {
			const inputQtyValue = this.querySelector('[name="quantity"]').value;
			document.querySelector('.sticky-button-cart [name="quantity"]').value = inputQtyValue;
		}
	}

	validateQtyRules() {
		const value = parseInt(this.input.value);
		if (this.input.min) {
			const min = parseInt(this.input.min);
			const buttonMinus = this.querySelector(".quantity__button[name='minus']");
			buttonMinus.classList.toggle('disabled', value <= min);
		}
		if (this.input.max) {
			const max = parseInt(this.input.max);
			const buttonPlus = this.querySelector(".quantity__button[name='plus']");
			buttonPlus.classList.toggle('disabled', value >= max);
		}
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function throttle(fn, delay) {
	let lastCall = 0;
	return function (...args) {
		const now = new Date().getTime();
		if (now - lastCall < delay) {
			return;
		}
		lastCall = now;
		return fn(...args);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	},
};

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent(focus = true) {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

			this.setAttribute('loaded', true);
			const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
			if (focus) deferredElement.focus();
			if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
				// force autoplay for safari
				deferredElement.play();
			}
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

/**
 * Update label when hover swatches item
 */
window.addEventListener('DOMContentLoaded', function () {
	const colorSwatches = document.querySelectorAll('.tpt-swatches-group .tpt-swatches__product-item');
	const colorSwatchesEl = document.querySelector('.tpt-swatches-group .tpt-swatch-group-label__value');

	var colorSwatchesActive = '';
	var priceSwatchesActive = '';

	if (document.querySelector('.tpt-swatches-group .tpt-swatches__product-item.active')) {
		colorSwatchesActive = document.querySelector('.tpt-swatches-group .tpt-swatches__product-item.active').getAttribute('data-color');
		priceSwatchesActive = document.querySelector('.tpt-swatches-group .tpt-swatches__product-item.active').getAttribute('data-price');
	}

	colorSwatches.forEach((item) => {
		item.addEventListener('mouseover', (event) => {
			const currentColor = item.getAttribute('data-color');
			const currentPrice = item.getAttribute('data-price');
			//const labelHtml = `<span class="tpt-swatch__color">${currentColor}</span> - <span class="tpt-swatch__price">${currentPrice}</span>`;
			const labelHtml = `<span class="tpt-swatch__color">${currentColor}</span>`;
			colorSwatchesEl.innerHTML = labelHtml;
		});

		item.addEventListener('mouseout', (event) => {
			//const labelHtml = `<span class="tpt-swatch__color">${colorSwatchesActive}</span> - <span class="tpt-swatch__price">${priceSwatchesActive}</span>`;
			const labelHtml = `<span class="tpt-swatch__color">${colorSwatchesActive}</span>`;
			colorSwatchesEl.innerHTML = labelHtml;
		});
	});
});

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);

		const labels = this.querySelectorAll('fieldset label');
		labels.forEach((label) => {
			label.addEventListener('click', this.toggleInput);
		});
	}

	toggleInput() {
		if (this.closest('.tpt-swatches-group')) {
			var radioBox = this.previousElementSibling;

			if (radioBox.checked == true) {
				setTimeout(() => {
					radioBox.checked = false;

					const swatches = document.querySelectorAll('.tpt-swatches-group .tpt-swatches__product-item');

					swatches.forEach((itemSwatches) => {
						itemSwatches.classList.remove('unavailable');
					});
				}, 100);

				return;
			}
		}
	}

	onVariantChange(event) {
		this.updateOptions();
		this.updateMasterId();
		this.updateSelectedSwatchValue(event);
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();
		this.tptUpateSwatch(event);

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
			if (element.tagName === 'SELECT') {
				return element.value;
			}
			if (element.tagName === 'FIELDSET') {
				return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
			}
		});
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateSelectedSwatchValue({ target }) {
		const { name, value, tagName } = target;

		if (tagName === 'SELECT' && target.selectedOptions.length) {
			const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
			const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
			if (!selectedDropdownSwatchValue) return;
			if (swatchValue) {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
				selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
			} else {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
				selectedDropdownSwatchValue.classList.add('swatch--unavailable');
			}
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
		}

		/**
		 * Update title value selection variant
		 */

		const titleHtml = '<span class="title-swatch-color">' + target.getAttribute('value') + '</span>';
		if (target.closest('fieldset')) {
			const variantLabel = target.closest('fieldset').querySelector('.form__label');

			if (variantLabel.querySelector('.title-swatch-color')) {
				variantLabel.querySelector('.title-swatch-color').remove();
			}

			variantLabel.insertAdjacentHTML('beforeend', titleHtml);
		}
	}

	tptUpateSwatch({ target }) {
		const { name, value, tagName } = target;
		const groupSwatch = this.closest('.tpt-swatches-group');
		const swatchItemString = groupSwatch.querySelectorAll('[data-tpt-swatches]');

		swatchItemString.forEach((swatchData) => {
			swatchData.closest('.tpt-swatches__product-item').classList.remove('unavailable');
			swatchData.closest('.tpt-swatches__product-item').classList.remove('available');

			const dataJson = JSON.parse(swatchData.innerHTML);

			var available = false;

			dataJson.forEach((variantItem) => {
				if (variantItem.available) {
					if (variantItem.option1 == value || variantItem.option2 == value || variantItem.option3 == value) {
						available = true;
					}
				}
			});

			if (available) {
				swatchData.closest('.tpt-swatches__product-item').classList.add('available');
			} else {
				swatchData.closest('.tpt-swatches__product-item').classList.add('unavailable');
			}
		});
	}

	updateMedia() {}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	updateVariantInput() {
		if (this.dataset.section == 'tpt-variants') {
			const inputVariant = document.querySelector('tpt-modal-variants input[name="id"]');
			inputVariant.value = this.currentVariant.id;
			//inputVariant.dispatchEvent(new Event('change', { bubbles: true }));
		} else {
			var productForms;

			if (this.closest('tpt-modal-component')) {
				productForms = document.querySelectorAll(`#product-form-tpt-quickview-${this.dataset.section}, #product-form-installment-tpt-quickview-${this.dataset.section}`);
			} else {
				productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
			}

			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');
				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter((variant) => this.querySelector(':checked').value === variant.option1);
		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected).map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(elementList, availableValuesList) {
		elementList.forEach((element) => {
			const value = element.getAttribute('value');
			const availableElement = availableValuesList.includes(value);

			if (element.tagName === 'INPUT') {
				element.classList.toggle('disabled', !availableElement);
			} else if (element.tagName === 'OPTION') {
				element.innerText = availableElement ? value : window.variantStrings.unavailable_with_option.replace('[value]', value);
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

		fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');

				/**
				 * Update product media gallery
				 */
				if (this.closest('.shopify-section')) {
					const gallaryProductContainer = this.closest('.shopify-section').querySelector('.tpt-product-media-gallery');

					if (gallaryProductContainer) {
						const mediaProductGallery = html.getElementById('ProductMediaGallery').innerHTML;

						if (html.querySelector('[data-variant-image]')) {
							gallaryProductContainer.innerHTML = mediaProductGallery;
						}
					}
				}

				/**
				 * Update product media gallery in quickview modal
				 */
				if (this.closest('.quickview-modal')) {
					const gallaryProductContainer = this.closest('.quickview-modal').querySelector('.tpt-product-media-gallery');

					if (gallaryProductContainer) {
						const mediaProductGallery = html.getElementById('ProductMediaGallery').innerHTML;

						if (html.querySelector('[data-variant-image]')) {
							gallaryProductContainer.innerHTML = mediaProductGallery;
						}
					}
				}

				/**
				 * end update product media gallery
				 */

				if (this.dataset.section == 'tpt-variants') {
					const priceHtml = html.querySelector('[id^="price-tpt-variants-"]');
					const buttonCartHtml = html.querySelector('.product-form__buttons');

					this.closest('.variants-container').querySelector('[id^="price-tpt-variants-"]').innerHTML = priceHtml.innerHTML;
					this.closest('.variants-container').querySelector('.product-form__buttons').innerHTML = buttonCartHtml.innerHTML;
				}

				var destination = document.getElementById(`price-${this.dataset.section}`);
				const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
				const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
				const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

				const volumePricingSource = html.getElementById(`Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

				const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
				const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

				const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
				const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
				const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

				if (volumeNote) volumeNote.classList.remove('hidden');
				if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
				if (qtyRules) qtyRules.classList.remove('hidden');

				/**
				 * Update price in modal quickview
				 */
				if (this.closest('.quickview-modal')) {
					if (this.closest('.quickview-modal').querySelector('.price-main')) {
						destination = this.closest('.quickview-modal').querySelector('.price-main');
					}
				}

				if (source && destination) destination.innerHTML = source.innerHTML;

				if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
				}

				if (volumePricingSource && volumePricingDestination) {
					volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
				}

				if (pricePerItemSource && pricePerItemDestination) {
					pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
					pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('hidden');

				if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

				var addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

				this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant,
					},
				});

				if (document.querySelector('.sticky-button-cart') && !this.closest('.quickview-modal')) {
					const newPriceHtml = document.querySelector('product-info [id^="price-template-"]').innerHTML;
					const isDisabled = document.querySelector('product-info .product-form__submit').getAttribute('disabled');
					const buttonAddCartText = document.querySelector('product-info .product-form__submit span').innerHTML;
					const stickyButtonAddCart = document.querySelector('.sticky-button-cart .sticky-add-cart');

					document.querySelector('.sticky-button-cart .sticky-add-cart .button-text').innerHTML = buttonAddCartText;

					if (isDisabled == 'disabled') {
						stickyButtonAddCart.setAttribute('disabled', 'disabled');
					} else {
						stickyButtonAddCart.removeAttribute('disabled');
					}

					document.querySelector('.sticky-button-cart .sticky-product_price').innerHTML = newPriceHtml;
				}
			});
	}

	toggleAddButtonQuickview(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-tpt-quickview-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		var productForm = document.getElementById(`product-form-${this.dataset.section}`);

		if (this.closest('.quickview-modal')) {
			productForm = document.getElementById(`product-form-tpt-quickview-${this.dataset.section}`);
		}

		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
		const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
		const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('hidden');
		if (inventory) inventory.classList.add('hidden');
		if (sku) sku.classList.add('hidden');
		if (pricePerItem) pricePerItem.classList.add('hidden');
		if (volumeNote) volumeNote.classList.add('hidden');
		if (volumeTable) volumeTable.classList.add('hidden');
		if (qtyRules) qtyRules.classList.add('hidden');
	}

	getVariantData() {
		this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);
